<section class="ifa-section ifa-404" *ngIf="isBrowser">
    <div class="ifa-container ifa-404__inner">
        <p class="ifa-eyebrow">Error 404</p>
        <h1 class="ifa-page-title">Page Not Found</h1>
        <p class="ifa-lead">The page you've requested cannot be found. Please check the spelling of the URL, or use one of the links below.</p>
        <div class="ifa-button-row">
            <a class="ifa-button ifa-button--primary" routerLink="/">Back to Homepage</a>
            <a class="ifa-button ifa-button--secondary" routerLink="/search">Search IFA.com</a>
        </div>
    </div>
</section>
